import React,{Component}   from 'react';


class Section$ extends Component {
    showDrawer = (data) => {
        this.props.enclosureShow(data.target.id,data.target.title)
    }
    render(){
        return(
            <div style={{textIndent: '2em'}}>
                <div style={{textAlign: 'center'}}>
                    <br/>
                    <h1 name="0-4" className="point" id="0-4">第五章 财务管理制度</h1></div>
                <div style={{textIndent: '2em'}}>
                    <br/>
                    <h2 name="0-4-0" className="point" id="0-4-0">一、报销制度管理细则及审批流程</h2>
                    <h3 name="0-4-0-0" className="point" id="0-4-0-0">1、费用报销管理细则</h3>
                    <h3 name="0-4-0-0-0" className="point" id="0-4-0-0-0">1.1 总则</h3>
                    <p>第一条 为加强公司财务管理，控制费用开支，本着精打细算、勤俭节约、有利工作的原则，根据国家规定和公司实际情况，特制定本办法。</p>
                    <p>第二条 公司运营经费实行分块核定，主要包括：业务费、招待费、误餐费、差旅费、日常办公、车辆、零星采购等。其中：差旅费包括因公临时被派到常驻工作地以外的地区工作，期间发生的往返交通费、住宿费、餐费补助、市内交通费等。业务招待费包括商务宴请、重要客户住宿、礼品费，用于因公接待、会议招待、对外工作的必要招待。日常办公管理费包括低值易耗办公用品购置费，快递费，办公电脑、打印机及耗材配件等购置费，网络服务费、房租、办公水电费，车辆使用费等。</p>
                    <p>第三条 费用发生前及费用报销时必须严格按照公司规定的流程办理。在审核报销费用过程中发现弄虚作假、违反公司报销制度、先斩后奏情形时，财务部有权拒绝报销相关费用。</p>
                    <h3 name="0-4-0-0-1" className="point" id="0-4-0-0-1">1.2、费用报销规定细则</h3>
                    <p>第四条 填写报销单应注意：根据费用性质填写对应单据，注明附件张数、报销时间段、金额大小写须完全一致(不得涂改)；报销单上简述费用内容或事由（需另附费用报销本记录具体明细），禁止在发票上书写。</p>
                    <p>第五条 费用报销时限：票据报销日期一般情况，当月票据当月报销，月底（25号及以后）的票据可延至下月报销，票据逾期两个月以上将不予受理。</p>
                    <p>第六条 票据丢失原则一律不允许报销，如有特殊情况，需本人附书面说明及相关证明，报部门第一责权人签字审批，交主管财务的副董事长审批签字后，在丢失票据金额的50%以内予以报销。</p>
                    <h3 name="0-4-0-0-2" className="point" id="0-4-0-0-2">1.3、费用的分类</h3>
                    <p>第七条 报销单分类</p>
                    <p>（一）《费用报销单》</p>
                    <p>1、业务费：包含业务支出、销售奖金、礼金等相关费用。</p>
                    <p>2、招待费：因业务需要宴请的餐费、旅游门票等相关费用，需在报销本上注明招待何人、陪同人数等；另需附原始单据（如付款记录、菜单等）；提供不全，则不予报销。</p>
                    <p>3、误餐费（暂试行）：业务人员和司机因公在市内耽误就餐作出的餐补（误餐费标准：市内早餐6元、午晚分别16元），由部门统计做好出车登记表，次月由部门统计统一报销，本人签字确认，事后不补。</p>
                    <p>4、车辆费用：</p>
                    <p>4.1、汽油费：由财务部统一充值加油卡，做好加油明细表登记；特殊情况下现金支付的，需在报销本上详细记录车牌号、行驶公里数；</p>
                    <p>4.2、高速费：每辆车辆都配有ETC，由司机自行充值并开具正式发票，报销时需附结算小票；</p>
                    <p>4.3、停车费：因公产生的停车费用；</p>
                    <p>4.4、维修保养等与车辆相关的费用；</p>
                    <p>5、交通费：员工因公办事或者加班产生的公交车、出租车、滴滴打车及代驾等费用，需在费用报销本上详细列明起始地点、到达地点；滴滴打车及代驾出具发票的同时需附行程单。</p>
                    <p>6、物流费：包含快递费（顺丰、京东由公司统一月结）、发运、收货、外雇费用。</p>
                    <p>7、通讯费：在由本人提出申请，经本部门由经理（支持机构）/总监（营销机构）签字→交主管财务的副董事长审批签字→财务部统一办理。
                    </p>
                    <p>8、办公用品：由财务部统一管理、统一采购（纸笔、文件夹，打印机耗材等）。</p>
                    <p>9、固定资产：由需求部门提交申请报告交资产部批准后，由专人统一采购，报销时需办理资产入库、出库手续，并附相关报告及票据，由经办人签字交财务审核后支付。</p>
                    <p>10、外协费用：因业务需要内部无法完成的如钣金、喷漆、零件加工等相关费用。</p>
                    <p>11、采购类：配件零星采购、工具采购（由申请人出具书面报告，报销时必须有怀远入库、出库单号）。</p>
                    <p>（二）《差旅费报销单》</p>
                    <p>1、各部门应根据工作计划，合理安排本部门员工的出差事宜。</p>
                    <p>2、交通费开支包括：因公出差往返火车、飞机等以及与所乘坐交通工具有关的必需支出：如订票手续费、机场建设费、燃油附加费、退票费等；还包括乘坐出租车、租用车辆等。</p>
                    <p>3、每笔差旅费都需要有完整的出发-返回的时间和地点，包含交通费（机票需打印行程单）、住宿费、出差补助，出差人员需统一填写《差旅费报销单》，详细注明出差地点、事由、交通工具等。
                        出差期间报销招待费，同时按比例(早餐20%、午餐或晚餐各40%)扣减出差人当天的伙食补贴。经理（支持机构）/总监（营销机构）及销售人员餐补标准为每天70元（对应客户为领导级别）、服务人员为每天50元。差旅费必须分次、按出差地点分开填列，并计算好出差天数，住宿、伙食补助和市内交通费等。（特殊情况另行审批，最终报销核定权归财务部。）</p>
                    <p>4、国际出差每日补贴30美元。（欧美及发达地区一事一议）</p>
                    <p>5、所有报销必须由本人整理，部门统计核对，按报销流程审批后交财务部出纳，要求单据的张数和合计金额必须准确无误填写，差旅费报销必须一次性提交所有票据，漏报后补报的票据将不予报销。</p>
                    <p>6、按差旅积分考核，(每季度考评一次) </p>
                    <p>京津冀外出差奖0-300分/次；非洲出差奖0-1000分/次；其它国际出差奖0-600分/次。</p>
                    <p>由经理（支持机构）/总监（营销机构）提报→副总裁/总裁助理/总经理（营销机构）签字→交主管财务的副董事长审批签字；</p>
                    <p>（三）《支出凭证》</p>
                    <p>1、业务退款：系统出库金额小于实收金额，由部门统计人员统一出具《支出凭证》作退款处理，简要写明出库单号、收款日期、收款方式及金额，注明收款人相关信息→交部门经理/总监审核签字→基地出纳验收→交主管财务的副董事长审批签字→出纳核销；</p>
                    <p>2、业务经费：由部门统计整理核对→交部门经理/总监审核签字→副总裁/总裁助理/营销机构总经理审核签字→基地出纳验收→交主管财务的副董事长审批签字→出纳核销；</p>
                    <p>（四） 其他专项支出</p>
                    <p>其他专项支出包括其他所有专门立项的费用(含咨询、广告、培训费、办公室装修及其他专项费用)支出。必须提交用款申请报告，报财务部备案。</p>

                    <h3 name="0-4-0-1" className="point" id="0-4-0-1">2、费用报销审批流程</h3>
                    <h4>一、副总裁/总裁助理/营销机构总经理 报销</h4>
                    <p>（郭军、徐桦、韩立学、高乐、郭海江、张少先、武晓亮、孟庆彪、刘永强、李栋卫、范晓瑞、郝惠东、李西安）</p>
                    <p>1、金额在1-10000元：由部门统计整理核对→基地出纳验收→交副董事长（财务负责人）审批签字→出纳核销；</p>
                    <p>2、金额10000元以上：由部门统计整理核对→总裁审批签字→基地出纳验收→交副董事长（财务负责人）审批签字→出纳核销；</p>
                    <h4>二、经理（支持机构）/总监（营销机构） 报销</h4>
                    <p>（范晓康、黎勇、蔺帅、张小雨、戴树春、王云涛、王云伟、吕建龙、霍涛、苗东、朱莹莹、刘天双、李信、张东生、冯燕飞）</p>
                    <p>1、金额1-2000元：由部门统计整理核对→基地出纳验收→交副董事长（财务负责人）审批签字→出纳核销；</p>
                    <p>2、金额在2000-30000元：由部门统计整理核对→交副总裁/总裁助理/营销机构总经理审核签字→基地出纳验收→交副董事长（财务负责人）审批签字→出纳核销；</p>
                    <p>3、金额30000元以上：由部门统计整理核对→交副总裁/总裁助理/营销机构总经理审核签字→总裁审批签字→基地出纳验收→交副董事长（财务负责人）审批签字→出纳核销；</p>
                    <h4>三、经理（支持机构）/总监（营销机构）以下员工报销</h4>
                    <p>1、金额1-5000元：由部门统计整理核对→交部门经理/总监审核签字→基地出纳验收→交副董事长（财务负责人）审批签字→出纳核销；</p>
                    <p>2、金额在5000元以上：由部门统计整理核对→交部门经理/总监审核签字→副总裁/总裁助理/营销机构总经理审核签字→基地出纳验收→交副董事长（财务负责人）审批签字→出纳核销；</p>
                    <h4>费用报销审批流程表 </h4>
                    <br/>
                    <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure51' title="《云豪集团2020年报销审批流程表》" onClick={(value)=>this.showDrawer(value)}>《云豪集团2020年报销审批流程表》</a></div>
                    <br/>
                    <h4>五、所有海外公司及消防业务直接报财务总监审核报销</h4>

                    <h4>注：主管财务的副董事长为傅雪梅</h4>

                    <h4>第三部分备用金借款审批流程</h4>

                    <h4>一、副总裁/总裁助理/营销机构总经理</h4>
                    <p>（郭军、徐桦、韩立学、高乐、郭海江、张少先、武晓亮、孟庆彪、刘永强、李栋卫、范晓瑞、郝惠东、李西安）</p>
                    <p>1、单笔金额在1-10000元：由本人写借款单→基地出纳→交副董事长（财务负责人）审批→出纳支出；）</p>
                    <p>2、单笔金额10000元以上：由本人写借款单→总裁审批签字→基地出纳→交副董事长（财务负责人）审批→出纳支出；</p>
                    <p>每月借款次数上限为2次，月底前必须报销当月所发生的费用，如不报销次月的借款单基地出纳有权拒收，特殊情况特殊申请。</p>
                    <h4>二、经理（支持机构）/总监（营销机构）</h4>
                    <p>（范晓康、黎勇、蔺帅、张小雨、戴树春、王云涛、王云伟、吕建龙、霍涛、苗东、朱莹莹、刘天双、李信、张东生、冯燕飞）</p>
                    <p>1、单笔金额1-2000元：由本人写借款单→基地出纳验收→交副董事长（财务负责人）审批→出纳支出；</p>
                    <p>2、单笔金额在2000-30000元：由本人写借款单→交副总裁/总裁助理/营销机构总经理审核签字→基地出纳→交副董事长（财务负责人）审批→出纳支出；</p>
                    <p>3、单笔金额30000元以上：由本人写借款单→交副总裁/总裁助理/营销机构总经理审核签字→总裁审批签字→基地出纳→交副董事长（财务负责人）审批→出纳支出；</p>
                    <p>每月借款次数上限为2次，月底前必须报销当月所发生的费用，如不报销次月的借款单基地出纳有权拒收，特殊情况特殊申请。</p>
                    <h4>三、经理（支持机构）/总监（营销机构）以下员工</h4>
                    <p>1、单笔金额1-5000元：由本人写借款单→部门统计核对→交部门经理/总监审核签字→基地出纳→交副董事长（财务负责人）审批→出纳支出；</p>
                    <p>2、单笔金额在5000元以上：由本人写借款单→部门统计核对→交部门经理/总监审核签字→副总裁/总裁助理/营销机构总经理审核签字→基地出纳→交副董事长（财务负责人）审批→出纳支出；</p>
                    <p>每月借款次数上限为2次，月底前必须报销当月所发生的费用，如不报销次月的借款单基地出纳有权拒收，特殊情况特殊申请。</p>
                    <p>四、专项请款（不包括业务奖金）：由本人写借款单（写明原因或附审批报告）→部门统计核对→交部门经理/总监审核签字→基地出纳→交副董事长（财务负责人）审批→出纳支出；</p>
                    <p>专项请款金额必须专款专用，业务结束后必须报销。</p>

                    <h2 name="0-4-1" className="point" id="0-4-1">二、应收应付账款管理细则</h2>
                    <h3 name="0-4-1-0" className="point" id="0-4-1-0">1、总则</h3>
                    <p>第一条 为保证公司能最大可能的利用客户信用拓展市场以利于销售公司的产品，同时又要以最小的坏账损失代价来保证公司资金安全，防范经营风险，并尽可能的缩短应收账款占用资金的时间，加快企业资金周转，提高企业资金的使用效率，特制定本制度。</p>
                    <p>第二条 本制度将往来账按其基本性质分为两大类，应收款类和应付款类。本制度所称应收账款，包括发出产品赊销所产生的应收账款和公司经营中发生的各类债权。</p>
                    <p>第三条 应收账款的管理部门为公司的财务部和相关业务部门，财务部负责数据传递和信息反馈，业务部门负责客户的联系和款项催收，财务部和业务部门共同负责客户信用额度的确定。</p>
                    <h3 name="0-4-1-1" className="point" id="0-4-1-1">2、客户资信管理</h3>
                    <p>第四条 客户信息档案的建立由相关业务部门完成，公司业务部门应在收集整理的基础上建立客户信息档案。</p>
                    <p>第五条 客户资料是客户管理的基础，由公司业务人员对客户进行访问、观察收集。业务人员对所了解的情况应随时汇总整理后交业务经理定期予以更新或补充，并及时更新相应的客户档案。</p>
                    <p>第六条 客户信息档案必须具备完整性、准确性、及时性。营销机构与财务部应定期保持沟通，相互反馈客户的相关信息。 </p>
                    <p>第七条 公司应制定客户走访标准，对不同资信的客户应指派人员定期走访，与客户保持联系，随时关注客户的相关信息，并及时汇总上报部门经理。</p>
                    <h3 name="0-4-1-2" className="point" id="0-4-1-2">3、产品赊销管理</h3>
                    <p>第八条
                        在市场开拓和产品销售中，应力争现款交易。若需要进行赊销，由总监（营销机构）根据客户资信情况进行审核后，报总经理（营销机构）审批。超过20万的赊销需报总裁批准。（按期结算的除外） </p>
                    <p>第九条 凡前次赊销款项在信用期限内未进行结款的，除特殊情况下客户能提供可靠的资金担保或经总经理批准外，一律不再发货和赊销。</p>
                    <h3 name="0-4-1-3" className="point" id="0-4-1-3">4、应收账款监控制度</h3>
                    <p>第十条 财务部会计应根据所签订的合同、协议要求的回款期限，每月与部门统计以及出纳核对一次债权性应收账款的回款和结算情况，严格监督每笔账款的回收和结算。</p>
                    <p>第十一条 业务人员全权负责对自己经手业务的账款回收，为此，应定期或不定期地对客户进行回访（电话或上门走访），回访客户时，如发现客户有异常现象，应及时上报总监（营销机构），并建议应采取的措施。如超过信用期限者，应按以下规定处理：
                    </p>
                    <p>（一）超过结算期限15天时，经办业务人员应及时催收同时上报总经理（营销机构）。 </p>
                    <p>（二）超过信用期限30天时且金额不超过10万元的，提交法务部；金额超过10万元以上的，提交法务部，并由总经理（营销机构）上报总裁。</p>
                    <p>第十二条 业务人员在销售产品和清收账款时不得有下列行为，一经发现，一律予以开除，并要求按期限赔偿，严重者移交司法部门，追究其法律责任。</p>
                    <p>(一）收款不报或积压收款。</p>
                    <p>(二）退货不报或积压退货。</p>
                    <p>(三)不依规定转售或转售图利。</p>
                    <h3 name="0-4-1-4" className="point" id="0-4-1-4">5、坏账管理制度</h3>
                    <p>第十三条 坏账是指企业无法收回或收回的可能性极小的应收款项。企业的应收账款符合下列条件之一的，应确认为坏账：</p>
                    <p>（一）债务人死亡，以其遗产清偿后仍然无法收回；</p>
                    <p>（二）债务人破产，以其破产财产清偿后仍然无法收回；</p>
                    <p>（三）债务人较长时期内未履行偿债义务，并有足够的证据表明无法收回或收回的可能性极小 。</p>
                    <p>（四）一旦发生坏账，业务人员需承担全部责任。</p>
                    <p>第十四条 公司可根据备抵法计提坏账准备，计入各期的管理费用，根据目前公司状况具体计提比例如下：</p>
                    <p>（一）账龄:满1年   计提比例:30%</p>
                    <p>（二）账龄:满2年   计提比例:60%</p>
                    <p>（三）账龄:2年以上   计提比例:100%</p>

                    <h3 name="0-4-1-5" className="point" id="0-4-1-5">6、应付账款管理</h3>
                    <p>第十五条 应付账款是企业在正常经营过程中，因购买材料、商品和接受劳务供应等而应付给供应单位的款项。</p>
                    <p>第十六条 预付货款前，应提交付款申请（附相应的合同），审批权限如下：</p>
                    部门总监（营销机构）签字→副总裁/总裁助理/总经理（营销机构）签字→主管财务的副董事长→出纳核对付款；
                    <p>第十七条 购买商品及材料的应付款，付款时应取得货物的验收入库单据。接受劳务的付款，应有相应的书面证明（预付款除外）。</p>
                    <p>第十八条 付货款的同时，应取得对方开具的合规发票。</p>
                    <p>第十九条 对存在质量问题的原材料货款，未经总裁批准，财务部拒绝付款。</p>
                    <p>第二十条 双方按季度核对账务，年度应出具书面对账函。</p>
                    <p>第二十一条 各类应付账款没有特殊要求的，应避免用现金支付。</p>

                    <h2 name="0-4-2" className="point" id="0-4-2">三、审计稽核细则</h2>
                    <h3 name="0-4-2-0" className="point" id="0-4-2-0">1、总则</h3>
                    <p>第一条 目的</p>
                    <p>为了规范企业内部审计管理工作，使审计工作制度化、法制化，根据国家审计法规结合实际情况，特制定本管理制度。</p>
                    <p>第二条 审计对象包括企业总部、全资子公司、分公司、控股公司的所有员工及参股企业的派驻人员。</p>
                    <p>第三条 内部审计机构的职权与责任。</p>
                    <p>1．召开企业、部门、下属企业有关审计工作会议。</p>
                    <p>2．参与重大经济决策的可行性论证或可行性报告事前审计。</p>
                    <p>3．要求被审计单位及时提供计划、预算、决算、合同协议、会计凭证、账簿等文件资料。</p>
                    <p>4．检查被审计单位的凭证、账簿、报表、资产。</p>
                    <p>5．对有关事项调查，有权要求有关单位和个人提供证明材料。</p>
                    <p>6．提出改进管理、提高效益的建议。</p>
                    <p>7．对违反财经法规行为提出纠正意见。</p>
                    <p>8．对严重违反财经法规、造成严重损失或浪费的人员，提出追究责任的建议。</p>
                    <p>9．对审计工作中发现的重大问题及时向总裁、董事会、监事会报告。</p>
                    <p>10．对阻挠破坏审计工作或拒绝提供资料的，有权向总裁提出建议，采取必要措施，追究有关人员责任。</p>
                    <p>11．参与制定、修订有关规章制度。</p>
                    <h3 name="0-4-2-1" className="point" id="0-4-2-1">2、内部审计的范围和内容</h3>
                    <p>第四条 内部审计范围。</p>
                    <p>1．与财务收支有关的经济活动。</p>
                    <p>2．财务计划的执行和决算。</p>
                    <p>3．企业资产的使用、管理及保值增值情况。</p>
                    <p>4．基建工程预、决算的真实合法性。</p>
                    <p>5．国家财经法律、法规执行情况。</p>
                    <p>6．有关人员离任的经济责任。</p>
                    <p>7．管理活动、行政活动。</p>
                    <p>8．其他认定事项。</p>
                    <p>第五条 审计工作内容。</p>
                    <p>1．审计财务计划及其预算的执行的决算。</p>
                    <p>2．对固定资产投资项目的立项、资金来源，以及预算、决算、竣工、开工进行审计。</p>
                    <p>3．审计资产管理情况。</p>
                    <p>4．审计经营成果，财务收支的真实性、合法性、效益性。</p>
                    <p>5．审计内部控制制度的健全、严密、有效性。</p>
                    <p>6．审计重要经济合同、契约的签订。</p>
                    <p>7．负责对各部门、下属企业领导离任进行审计。</p>
                    <p>8．审计联营、合资、合作企业和项目投入资金、财产使用及其效果。</p>
                    <p>9．配合国家审计机关和审计（会计）师事务所对和有关部门的审计。</p>
                    <p>10．其他审计事项。</p>
                    <p>11．向总裁、审计机关报送审计工作计划、报告、统计报表等资料。</p>
                    <h3 name="0-4-2-2" className="point" id="0-4-2-2">3、内部审计工作程序和注意事项</h3>
                    <p>第六条 内部审计工作程序。</p>
                    <p>1．制定企业审计计划和工作方案，经总裁批准组织实施，必要内容报送审计机关。</p>
                    <p>2．书面通告被审计单位，说明审计内容、种类、方式、时间。</p>
                    <p>3．实施审计。审计人员可采取审查凭证、账表、文件、资料、检查现金、实物、向有关单位和人员调查取证等措施。</p>
                    <p>4．提出审计报告，作审计结论及审计处理意见。</p>
                    <p>5．下达审查处理决定。</p>
                    <p>6．复审。被审单位、个人在接到审查处理决定10天内，向审计部提出书面复审申请，经总裁批准，组织复审。</p>
                    <p>7．进行后续审计。</p>
                    <p>第七条 审计程序过程注意事项。</p>
                    <p>1．审计部可以临时成立审计小组进行专项审计工作。</p>
                    <p>2．审计前，应向被审计单位出示由总经理签章的审计通知书及授权审计通知书。</p>
                    <p>3．审计处理决定由总裁批准下达。</p>
                    <p>4．复议期间，原审计结论和决定必须照常执行。</p>
                    <p>5．重大事项审计报告报董事会、监事会备案。</p>
                    <p>6．审计过程中若发现问题，可随时向企业报告及时制止。</p>

                    <h3 name="0-4-2-3" className="point" id="0-4-2-3">4、审计档案管理</h3>
                    <p>第八条 审计部门应建立、健全审计档案管理制度。</p>
                    <p>第九条 审计档案管理范围规定如下。</p>
                    <p>1．审计通知书和审计方案。</p>
                    <p>2．审计报告及其附件。</p>
                    <p>3．审计记录、审计工作底稿和审计证据。</p>
                    <p>4．反映被审计单位和个人业务活动的书面文件。</p>
                    <p>5．总经理对审计事项或审计报告的指示、批复和意见。</p>
                    <p>6．审计处理决定以及执行情况报告。</p>
                    <p>7．申诉、申请复审报告。</p>
                    <p>8．复审和后续审计的资料。</p>
                    <p>9．其他应保存的资料。</p>
                    <p>第十条 审计档案管理参考企业档案管理、保密管理等办法执行。</p>
                    <h3 name="0-4-2-4" className="point" id="0-4-2-4">5、奖励与处罚</h3>
                    <p>第十一条 审计人员对审计对象的奉公守法、绩效显著行为向总裁提出各类奖励建议。</p>
                    <p>第十二条 在审计过程中，有下列行为之一的单位和个人，审计人员应根据情节轻重，向总裁提出处罚建议。</p>
                    <p>1．拒绝提供有关文件、凭证、账表、资料和证明材料的。</p>
                    <p>2．阻挠审计人员行使职权，抗拒、破坏监督检查的。</p>
                    <p>3．弄虚作假、隐瞒事实真相的。</p>
                    <p>4．拒不执行审计结论和决定的。</p>
                    <p>5．打击报复审计人员或举报人的。</p>
                    <p>第十三条 对有下列行为的审计人员，根据情节轻重给予各类处罚。</p>
                    <p>1．利用职权谋取私利的。</p>
                    <p>2．弄虚作假、徇私舞弊的。</p>
                    <p>3．玩忽职守，给企业造成重大损失的。</p>
                    <p>4．泄露企业秘密的。</p>
                    <p>第十四条 对审计过程中的以上行为，构成犯罪的，提请司法机关依法追究刑事责任。
                    </p>
                    <h3>第六部分 附 则</h3>
                    <p>第十五条 本办法由企业审计部解释、修订与补充，经企业董事会通过颁布执行。
                    </p>

                    <h2 name="0-4-3" className="point" id="0-4-3">四、印章管理细则
                    </h2>
                    <h4>第一条 目的</h4>
                    <p>为保证公章使用的合法性、严肃性和可靠性，杜绝违法行为，维护公司利益，特制订本管理制度。</p>
                    <h4>第二条 适用范围</h4>
                    <p>本制度适用于集团公司及其子公司。</p>
                    <h3 name="0-4-3-0" className="point" id="0-4-3-0">1、印章的刻制和启用 </h3>
                    <p>一、印章的刻制</p>
                    <p>1、公司印章的刻制均须报集团公司财务部核准，到公安机关相关部门办理刻制手续（适用于集团本部直接管理的公司）。</p>
                    <p>2、印章的形体和规格，按国家有关规定执行。</p>
                    <p>二、印章的启用</p>
                    <p>1、新印章启用前要做好戳记，并留样保存，以便备查。</p>
                    <p>2、印章启用应报副董事长批准，并下发启用通知，注明启用日期、发放单位和使用范围。</p>

                    <h3 name="0-4-3-1" className="point" id="0-4-3-1">2、印章的保管、交接和停用</h3>
                    <p>一、公司各类印章必须有专人保管</p>
                    <p>1、集团统一管理的各公司，由集团财务部统一指定专人管理。
                    </p>
                    <p>2、印章保管须有记录，注明公章名称、颁发部门、枚数、收到日期、启用日期、领取人、保管人、批准人、图样等信息。
                    </p>
                    <p>3、严禁员工私自将公司印章带出公司使用。若因工作需要，确需将印章带出使用的，由用印人填写《印鉴使用签批单》→部门经理（支持机构）/总监（营销机构）签批→副董事长批准；印章使用完及时归还，并对印章在此期间的使用后果承担一切责任。</p>
                    <p>4、 印章保管人因事离岗时，须由副董事长指定人员暂时代管，以免贻误工作。</p>
                    <p>二、印章保管必须安全可靠，加锁保存，不可私自委托他人代管。</p>
                    <p>三、印章保管有异常现象或遗失，应保护现场，及时汇报，配合查处。</p>
                    <p>四、印章移交须办理手续，签署移交证明，注明移交人、接交人、监交人、移交时间、图样等信息。</p>
                    <p>五、有下列情况，相关印章须停用：</p>
                    <p>1、公司名称变动；</p>
                    <p>2、印章使用损坏；</p>
                    <p>3、印章遗失或被窃，声明作废。</p>
                    <p>六、印章停用时由财务部负责封存或销毁，建立印章上交、存档、销毁的登记档案。 </p>
                    <h3 name="0-4-3-2" className="point" id="0-4-3-2">3、印章使用</h3>
                    <p>一、使用范围如下：
                    </p>
                    <p>1、凡属以公司名义对外发文、开具介绍信、报送报表等一律加盖公司公章；</p>
                    <p>3、凡属合同类的用合同专用章；</p>
                    <p>4、凡属财务会计业务的用财务专用章。</p>
                    <p>二、使用程序</p>
                    <p>1、公司业务合同、项目协议、授权书、承诺书等用印都须先经部门经理（支持机构）/总监（营销机构）审核、副董事长批准，填写《用印登记表》；</p>
                    <p>2、印章使用必须建立用章登记制度，严格审批手续，不符合规定的和不经相关领导签发的文件、合同等，印章管理人有权拒印。</p>
                    <p>3、严禁在空白合同、协议、证明及介绍信上用印。因工作特殊确需用印时，须经副董事长签字同意方可；待工作结束后，必须及时向财务总监汇报用印空白文件的使用情况，未使用的必须立即收回作废。</p>

                    <h3 name="0-4-3-3" className="point" id="0-4-3-3">4、违纪处理</h3>
                    <p>违反以上规定者，公司将追究相关人员的责任，若给公司造成经济损失或不良社会影响者，公司将追究其法律责任。</p>
                    <h2 name="0-4-4" className="point" id="0-4-4">五、合同管理细则</h2>
                    <h3 name="0-4-4-0" className="point" id="0-4-4-0">1、总则</h3>
                    <p>一、公司对外签订的各类合同一律适用本制度。</p>
                    <p>二、合同管理是企业管理的一项重要内容，搞好合同管理，对于公司经济活动的开展和经济利益的取得，都有积极的意义。各级领导干部、法人委托人以及其他有关人员，都必须严格遵守、切实执行本制度。各有关部门必须互相配合，共同努力，搞好公司以"重合同、守信誉"为核心的合同管理工作。</p>
                    <h3 name="0-4-4-1" className="point" id="0-4-4-1">2、审查批准</h3>
                    <p>三、合同在正式签订前，必须按规定上报领导审查批准后，方能正式签订。</p>
                    <p>四、合同审批权限如下：</p>
                    <p>1、由部门经理（支持机构）/总监（营销机构）具体经办，拟订初稿后必须经副董事长/总裁助理/总经理（营销机构）审阅后按合同审批权限审批。</p>
                    <p>2、标的超过20万元的；有关联营、合资、合作、涉外合同，均由总裁审批。</p>
                    <p>五、重要合同（金额20万以上或性质特殊）必须经法律顾问审查，合同审查的要点是：</p>
                    <p>1、合同的合法性。包括：当事人有无签订、履行该合同的权利能力和行为能力；合同内容是否符合国家法律、政策和本制度规定。</p>
                    <p>2、合同的严密性。包括：合同应具备的条款是否齐全；当事人双方的权利、义务是否具体、明确；文字表述是否确切无误。</p>
                    <p>3、合同的可行性。包括：当事人双方特别是对方是否具备履行合同的能力、条件；预计取得的经济效益和可能承担的风险；合同非正常履行时可能受到的经济损失。</p>
                    <p>六、根据法律规定或实际需要，合同还应当或可以呈报上级主管机关鉴证、批准，或报工商行政管理部门鉴证，或请公证处公证。</p>
                    <h3 name="0-4-4-2" className="point" id="0-4-4-2">3、合同签订</h3>
                    <p>七、合同谈判须由部门经理（支持机构）/总监（营销机构）与相关业务人员共同参加，不得一个人直接与对方谈判合同。</p>
                    <p>八、签订合同必须遵守国家的法律、政策及有关规定。</p>
                    <p>九、合同一律采用书面格式，并必须采用统一合同文本。
                    </p>
                    <p>十、合同对各方当事人权利、义务的规定必须明确、具体，文字表达要清楚、准确。</p>

                    <h3 name="0-4-4-3" className="point" id="0-4-4-3">4、合同履行</h3>
                    <p>十一、合同依法成立，既具有法律约束力。一切与合同有关的部门、人员都必须本着"重合同、守信誉"的原则。严格执行合同所规定的义务，确保合同的实际履行或全面履行。</p>
                    <p>十二、合同履行完毕的标准，应以合同条款或法律规定为准。没有合同条款或法律规定的，一般应以物资交清，工程竣工并验收合格、价款结清、无遗留交涉手续为准。</p>
                    <p>十三、总经理、财务部及有关部门负责人应随时了解、掌握合同的履行情况，发现问题及时处理或汇报。否则，造成合同不能履行、不能完全履行的，要追究有关人员的责任。</p>

                    <h3 name="0-4-4-4" className="point" id="0-4-4-4">5、合同变更、解除</h3>
                    <p>十四、在合同履行过程中，碰到困难的，首先应尽一切努力克服困难，尽力保障合同的履行。如实际履行或适当履行确有人力不可克服的困难而需变更，解除合同时，应在法律规定或合理期限内与对方当事人进行协商。</p>
                    <p>十五、对方当事人提出变更、解除合同的，应从维护本公司合法权益出发，从严控制。</p>
                    <p>十六、变更、解除合同，必须符合《合同法》的规定，并应在公司内办理有关的手续。</p>
                    <p>十七、变更、解除合同的手续，应按本制度规定的审批权限和程序执行。</p>
                    十八、变更、解除合同，一律必需采用书面形式(包括当事人双方的信件、函电、电传等)，口头形式一律无效。
                    <p>十九、变更、解除合同的协议在未达成或未批准之前，原合同仍有效，仍应履行。但特殊情况经双方一致同意的例外。</p>
                    <p>二十、因变更、解除合同而使当事人的利益遭受损失的，除法律允许免责任的以外，均应承担相应的责任，并在变更、解除合同的协议书中明确规定。</p>
                    <p>二十一、以变更、解除合同为名，行以权谋私、假公济私之实，损公肥私的，一经发现，从严惩处。</p>
                    <h3 name="0-4-4-5" className="point" id="0-4-4-5">6、纠纷处理</h3>
                    <p>二十二、合同在履行过程中如与对方当事人发生纠纷的，应按《合同法》等有关法规和本《制度》规定妥善处理。</p>
                    <p>二十三、合同纠纷由有关业务部门与法律顾问负责处理，经办人对纠纷的处理必须具体负责到底。</p>
                    <p>二十四、处理合同纠纷的原则是：</p>
                    <p>1、坚持以事实为依据、以法律为准绳，法律没规定的，以国家政策或合同条款为准。</p>
                    <p>2、以双方协商解决为基本办法。纠纷发生后，应及时与对方当事人友好协商，在既维护本公司合法权益，又不侵犯对方合法权益的基础上，互谅互让，达成协议，解决纠纷。</p>
                    <p>3、因对方责任引起的纠纷，应坚持原则，保障我方合法权益不受侵犯；因我方责任引起的纠纷，应尊重对方的合法权益，主动承担责任，并尽量采取补救措施，减少我方损失；因双方责任引起的纠纷，应实事求是，分清主次，合情合理解决。</p>
                    <h3 name="0-4-4-6" className="point" id="0-4-4-6">7、合同管理</h3>
                    <p>二十五、所有部门的合同均同时交财务部备案；各部门管理本部门的合同。</p>
                    <p>二十六、财务部同有关部门认真做好合同管理的基础工作。具体如下：</p>
                    <p>1、建立合同档案。</p>
                    <p>2、建立合同管理台帐。</p>
                    <p>3、填写"合同情况月报表"。</p>
                    <p>二十七、适用范围</p>
                    <p>本制度适用于公司、所属各公司对外签订、履行的建立民事权利义务关系的各类合同、协议等，包括买卖合同、借款合同、租赁合同、加工承揽合同、运输合同、资产转让合同、仓储合同、服务合同等。</p>
                    <h2 name="0-4-7" className="point" id="0-4-7">六、现金、支票、发票管理细则</h2>
                    <h3 name="0-4-7-0" className="point" id="0-4-7-0">1、现金管理细则</h3>
                    <h4>第一条 现金收入</h4>
                    <p>1、现金结算：出纳在接到业务部门出具的销售单据时，客户要求现金结算的，在审核无误后收取现金款项，当面点清，并签字确认，登记现金日记账。</p>
                    <p>2、POS机刷卡结算：出纳在接到业务人员出具的销售单据时，客户要求需要刷卡支付的，按单据金额收取，签字确认。登记刷卡结算明细表。</p>
                    <p>3、微信/支付宝/银行卡收款：客户根据单据金额要求微信/支付宝/银行卡结算的，需支付给财务指定的账户，待财务确认到账后，出纳签字并做好收款记录明细表。</p>
                    <p>4、其他收入：一般为基地废品、废机油收入、会所其他收入等，由经手人交现金至财务，财务人员必须出具收据并由交款人、收款人签字确认，事项完结后记入现金日记账。</p>

                    <h4>第二条 现金支出</h4>
                    <p>1、现金借款申请：用款人员请款时需填写《借款单》，按审核权限规定报上级签核。</p>
                    <p>（1）金额在2000元以下（含2000元）：《借款单》+经办人+部门总监/经理（第一责权人不在时，可微信批复，后补签字）</p>
                    <p>（2）金额在2000元以上,10000元以下（含10000元）：《借款单》+经办人+部门总监/经理+副董事长（财务部负责人）（提前一天报备）</p>
                    <p>（3）金额在10000元以上：《借款单》+经办人+部门总监/经理+副董事长（财务部负责人）+董事长批复后的申请报告（提前一天报备）</p>
                    <p>2、如为采购类借款，还需填制采购申请，由相关领导签署意见后，再按审核权限规定报上级签核，财务部根据申请金额安排现金支付或汇款支付。</p>
                    <p>3、支付：出纳根据审核后的《借款单》，向收款人支付款项。</p>
                    <p>4、结算：用款人员需在公务完毕后1个月内到财务部报销；</p>
                    <p>5、个人借款：</p>
                    <p>（1）金额5000以下的，申请人+部门总监/经理（第一责权人）签字批复的申请报告，交财务部审批发放。</p>
                    <p>（2）金额5000以上的，申请人部门总监/经理（第一责权人）+董事长批复后的申请报告，交财务部审批发放。</p>
                    <h3 name="0-4-7-1" className="point"
                        id="0-4-7-1">2、支票管理细则</h3>
                    <h4>第一条 支票的管理</h4>
                    <p>1、支票的使用：企业人员需用支票时，领用时应事先将支票登记好，填写收款单位、支票用途，支票号码、金额等，</p>
                    <p>2、支票的管理：</p>
                    <p>（1）空白支票和支票印鉴，必须由专人负责保管。支票必须随签发、随盖章。不得事先盖章备用，严防支票遗失和被盗。</p>
                    <p>（2）财务部门指定专人负责支票的购买及使用。</p>
                    <h4>第二条 支票的签发</h4>
                    <p>（1）签发支票，出纳按用款申请签发支票，要求填写真实、齐全，字迹要清晰，不得更改大小写金额，为避免签发空头支票，财务人员应准确地控制银行存款余额，及时正确地记载账务，定期与银行对账单进行核对，发现问题及时解决。</p>
                    <p>（2）过期，作废支票要按号订在原始凭证序号中，妥善保管，不准将支票乱扔乱放。</p>
                    <h4>第三条 支票的收取</h4>
                    <p>1、出纳在接到业务部门出具的销售单据时，客户要求支票结算的，审核无误后收取票据，收取支票时，需要检查出票日期、金额，有无密码并留取业务单位财务人员电话，签字确认。登记支票明细表，并及时将支票带昌平财务入账。</p>

                    <h3 name="0-4-7-2" className="point" id="0-4-7-2">3、发票管理细则</h3>
                    <h4>第一条 发票的取得 </h4>
                    <p>1、发票取得：报销人必须取得相应的合法票据：业务发生索取发票的顺序依次是：增值税专用发票、其次是普通发票或电子普票。</p>
                    <p>2、发票审核：含普通发票、增值税专用发票、电子普票：开票信息审核（公司名称、税号是否正确；地址、电话、开户行及账号）；发票金额是否与发生金额一致；发票专用章是否清晰，如发票明细多项，必须附明细清单。</p>
                    <p>3、对票据信息不完善，不规范，不能说明出处及原因的，财务部有权拒绝报销。</p>
                    <p>4、发票的种类及要求：关于费用报销发票的说明，在公司内部，为了报销发票的明确性，发票分为以下三类：</p>
                    <p>A类ǀ（开增值税专用发票）：办公用品、耗材、电脑配件、汽油票、汽车维修费、汽车配件发票、住宿费（有增值税资质)、劳保用品、快递费、体育用品</p>
                    <p>A类ǁ（开普通发票）：住宿费（无增值税资质)、过路费、停车费、清洁用品、水费（桶装水）、通讯费、公交地铁充值发票、打车发票、火车票（仅限公司员工）、飞机票（仅限公司员工）、药品（日常使用药物）</p>
                    <p>B类（开普通发票）：烟、酒、礼品、化妆品、香水、服装鞋帽、娱乐。</p>
                    <p>C类（开普通发票）：餐费、食品、日用品</p>
                    <p>4、所有票据，索要原则依次是：增值税专用发票，普通发票或电子普通发票；定额发票。如遇特殊情况无票时需附无票说明，经部门经理签字确认，由财务部审核后方可报销。报销单据必须真实、完整、准确、合规，否则财务部有权拒收，特殊情况需报请董事长签署意见。</p>
                </div>
            </div>
        )
    }

}   


export default Section$;